import { bridgelessChainInfo } from '@/config'
import { isNftFullyUnlocked, isPositiveAtomic, sumAtomic } from '@/helpers'
import { CoinAmount, Nft } from '@/types'

interface Params {
  nft: Nft | null
  isWalletConnected: boolean
  isOwner: boolean
  balances?: CoinAmount[]
  hasDelegation: boolean
  withdrawableAtomic?: string
  hasActiveUnbonding: boolean
}

export function useSelectedNftActions({
  nft,
  isWalletConnected,
  isOwner,
  balances,
  hasDelegation,
  withdrawableAtomic,
  hasActiveUnbonding,
}: Params) {
  const visible = Boolean(isWalletConnected && isOwner && nft)
  if (!visible || !nft) {
    return { visible: false as const }
  }

  const spendableAtomic = sumAtomic(
    (balances ?? [])
      .filter(
        b => b.denom === bridgelessChainInfo.stakeCurrency.coinMinimalDenom,
      )
      .map(b => b.amount),
  )

  return {
    visible: true,
    canDelegate: isPositiveAtomic(spendableAtomic),
    canWithdraw: !hasDelegation && isPositiveAtomic(withdrawableAtomic),
    canTopUp: !isNftFullyUnlocked(nft),
    hasDelegation: hasDelegation && !hasActiveUnbonding,
  }
}
